// extracted by mini-css-extract-plugin
export default {"item-card":"style_item-card__skPUE","icon-cancel":"style_icon-cancel__o98oX","main-contaier":"style_main-contaier__NVUYN"};